module.exports = __webpack_public_path__ + "img/image13.840e54cb.png";